import Tab from './Tab';
import Tabs from './Tabs';
import SubTab from './SubTab';
import SubTabs from './SubTabs';

export { Tab, Tabs, SubTab, SubTabs };
